import { textAreaControl } from '../../../../../constants/form-control/core/common/textarea/textarea';
import { textBoxControl } from '../../../../../constants/form-control/core/common/textbox/textbox';
import { textBoxRequiredControl } from '../../../../../constants/form-control/core/common/textbox/textbox-required';
import { FormControlUtil } from '../../../../../core/utils/form-control';

export const TaskGroupListActionControls = {
  task_group: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'task_group',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Sub Task Name' }),
  }),
  comment: FormControlUtil.mergeFormControl(textBoxControl, {
    key: 'comment',
    templateOptions: FormControlUtil.mergeFormControl(textBoxControl.templateOptions, { label: 'Comment' }),
  }),
};

export enum TaskGroupStatus {
  Done = 'Done',
  NotDone = 'NotDone',
  Add = 'Add',
  Delete = 'Delete',

}

export enum ShiftStatus {
  None = 'NONE',
  OnBreak = 'ONBREAK'
}
